const DEFAULT_NUMBER = "918006331010";
const DEFAULT_MESSAGE = "Namaste RydeCast, mujhe Slate 01 package ke baare mein jaanna hai.";

export const WHATSAPP_DISPLAY = "+91 80063 31010";

export const getWhatsAppUrl = (message = process.env.REACT_APP_WHATSAPP_MESSAGE || DEFAULT_MESSAGE) => {
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_NUMBER).replace(/\D/g, "");
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};
